import {
  BussinessIcon,
  FamilyIcon,
  FriendsIcon,
  FavoriteDeleteIcon,
  ProfileIcon,
} from '@assets/icons';

const REVİEW_TYPES = {
  BUSSINESS: 'business',
  COUPLES: 'couples',
  SOLO: 'solo',
  FAMILY: 'family',
  FRIENDS: 'friends',
};

const REVİEW_TYPES_BY_STRING = {
  BUSSINESS: 'İş',
  COUPLES: 'Çift',
  SOLO: 'Yalnız seyahat',
  FAMILY: 'Aile',
  FRIENDS: 'Arkadaş kaçamakları',
};

export const getReviewIcon = (type: string) => {
  switch (type) {
    case REVİEW_TYPES.BUSSINESS:
      return BussinessIcon;
    case REVİEW_TYPES.COUPLES:
      return FavoriteDeleteIcon;
    case REVİEW_TYPES.SOLO:
      return ProfileIcon;
    case REVİEW_TYPES.FAMILY:
      return FamilyIcon;
    case REVİEW_TYPES.FRIENDS:
      return FriendsIcon;
    case REVİEW_TYPES_BY_STRING.BUSSINESS:
      return BussinessIcon;
    case REVİEW_TYPES_BY_STRING.COUPLES:
      return FavoriteDeleteIcon;
    case REVİEW_TYPES_BY_STRING.SOLO:
      return ProfileIcon;
    case REVİEW_TYPES_BY_STRING.FAMILY:
      return FamilyIcon;
    case REVİEW_TYPES_BY_STRING.FRIENDS:
      return FriendsIcon;

    default:
      return undefined;
  }
};

export const getRating = (type: number) => {
  if (type >= 4.5) {
    return 'Mükemmel';
  } else if (type >= 4 && type < 4.5) {
    return 'Çok iyi';
  } else if (type >= 3 && type < 4) {
    return 'İyi';
  } else if (type < 3) {
    return 'Orta';
  }
};

export const getRatingAboveFour = (type: number) => type >= 4;
